module.exports = __webpack_public_path__ + "img/angels.697682a9.svg";